import * as React from 'react';
import clsx from 'clsx';
// @ts-ignore
import styles from './StatusBadge.module.scss?module';

export type StatusBadgeVariant =
  | 'neutral'
  | 'info'
  | 'pending'
  | 'positive'
  | 'negative'
  | 'accent';

interface StatusBadgeProps {
  variant?: StatusBadgeVariant;
  className?: string;
  children: React.ReactNode;
}

/* Status chip for lists (listing requests, order delivery status) and values
   (accent, e.g. a discount): neutral on the InfoPill surface; the coloured
   variants on the tinted surface of their family, text in the dark step of the
   same family (Marketing 20.10.2026 / P-5087 palette roles). */
export default function StatusBadge({
  variant = 'neutral',
  className,
  children,
}: StatusBadgeProps) {
  return (
    <span className={clsx(styles.badge, styles[variant], className)}>
      {children}
    </span>
  );
}
